import React from 'react';

const PhotoPickerPreview = ({ config }) => {
  return (
    <div className="w-full h-full flex items-center justify-center bg-gray-900 p-4" style={{ minWidth: 0, minHeight: 0, boxSizing: 'border-box' }}>
      <div className="max-w-md w-full space-y-4" style={{ maxWidth: 'calc(100% - 32px)' }}>
        <div className="bg-gray-800 rounded-lg p-6 text-center">
          <div className="mb-4">
            <svg
              className="mx-auto h-16 w-16 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-white mb-2">Photo Picker</h3>
          <div className="text-sm text-gray-400 space-y-1">
            <p>Mode: <span className="text-white">{config.selectionMode}</span></p>
            {config.selectionMode === 'multiple' && (
              <p>Max Count: <span className="text-white">{config.maxSelectionCount}</span></p>
            )}
            <p>Source: <span className="text-white">{config.sourceType}</span></p>
            <p>Filter: <span className="text-white">{config.filterType}</span></p>
            {config.cropEnabled && (
              <p>Crop: <span className="text-white">{config.cropShape}</span></p>
            )}
            <p>Editing: <span className="text-white">{config.allowsEditing ? 'Yes' : 'No'}</span></p>
          </div>
          <button className="mt-4 px-6 py-2 bg-gradient-primary bg-gradient-primary-hover rounded text-white text-sm font-medium">
            {config.sourceType === 'camera' ? 'Open Camera' : 'Select Photos'}
          </button>
        </div>
        <div className="text-xs text-gray-500 text-center">
          Preview shows configuration. Actual picker will use PhotosPicker API in SwiftUI.
        </div>
      </div>
    </div>
  );
};

export default PhotoPickerPreview;

